import React, {useEffect} from "react";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";

import {fetchDataNew} from "../../../hook/axios.hook";
import {getCurrentUser} from "../../../slices/UserSlice";
import {decodeCurrencySymbol} from "../../../utilities/currencyFormat";
import usePagination from "../../../utilities/hooks/usePagination";
import ReactTable from "../../conteiners/ReactTable";
import useColumns from "../../Requests/OrderProcessing/utils/hooks/useColumns";

const CURR_DATA_COLUMNS = Object.freeze([
  {
    header: "Currency",
    accessorKey: "currency",
    size: 70,
    isSortable: true,
  },
  {
    header: "Official rate",
    accessorKey: "ecbRate",
    size: 70,
  },
  {
    header: "PR",
    accessorKey: "purchaseRate",
    size: 70,
  },
  {
    header: "SR",
    accessorKey: "saleRate",
    size: 70,
  },
]);

const CurrData = ({rates, setRates, ratesUpdateTime}) => {
  const {t} = useTranslation();

  const user = useSelector(getCurrentUser);
  const orgStructureId = user?.orgStructure?.orgStructureId;

  const {page, setPage, onPaginate} = usePagination();

  useEffect(() => {
    if (!orgStructureId || Date.now() - ratesUpdateTime?.current < 10 * 1000) return;

    try {
      fetchDataNew("/v2/finance/rates", "get", {
        params: {
          type: "active",
          orgStructureId,
          page: page?.currentPage || 1,
          pageSize: 1000,
        },
      }).then(data => {
        ratesUpdateTime.current = Date.now();
        const newRates = data?.rates || [];
        setPage(data);
        setRates(prev => (data.currentPage === 1 ? newRates : [...(prev || []), ...newRates]));
      });
    } catch (error) {
      console.error(error);
    }
  }, [orgStructureId, page.currentPage, ratesUpdateTime?.current, rates?.length]);

  const columns = useColumns(CURR_DATA_COLUMNS);

  const data =
    rates?.map(({exchangeRateId, ecbRate, currency, purchaseRate, saleRate}) => ({
      id: exchangeRateId,
      currency: `${currency?.shortName || ""} ${currency?.symbol ? `(${decodeCurrencySymbol(currency?.symbol)})` : ""}`,
      ecbRate,
      purchaseRate,
      saleRate,
    })) || [];

  return (
    <div className="fcCol aistr gap2x" style={{height: "30rem"}}>
      <ReactTable
        columns={columns}
        defaultData={data}
        paginatable
        page={page?.currentPage}
        totalPages={page?.totalPages}
        onPaginate={onPaginate}
        selectable={false}
      />
      {!data?.length && t("No today rates")}
    </div>
  );
};

export default CurrData;
